import classnames from 'classnames';
import React, {
  DetailedHTMLProps,
  InputHTMLAttributes,
  forwardRef,
} from 'react';

const CSS = require('./Input.module.scss');

interface InputProps
  extends Partial<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
  > {
  className?: string;
  hasError?: boolean;
  variant?: 'medium' | 'large';
  [key: string]: any;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, hasError, variant = 'medium', ...rest }, ref) => {
    const classes = classnames(CSS.Input, {
      [CSS.LargeInput]: variant === 'large',
      [CSS.Error]: hasError,
      [className]: className,
    });

    return <input className={classes} ref={ref} {...rest} />;
  },
);

export default Input;
